// extracted by mini-css-extract-plugin
export default {"uploadModal":"GroupTalkTextInput_uploadModal__KGsVS","groupTalkTextInputClose":"GroupTalkTextInput_groupTalkTextInputClose__HRrnG"};